<template>
    <footer class="footer">
        <pre>{{copyright}}</pre>
        <!-- <a href="http://www.zhuofan.net" target="_blank">技术支持：深圳市卓帆技术有限公司</a>
        <a href="javascript:;">联系电话：0755-21610755</a>
        -->
    </footer>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
        }
    },
    computed:{
        copyright(){
            let platform = this.$store.getters['user/platform'];
            return platform && platform.copyright? platform.copyright : '';
            
            
        }
    },
    methods: {
    },
}
</script>
<style lang='scss' scoped>
</style>